<ion-content class="ion-no-padding">
  <form class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Offer Review ({{packageId}})</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button class="filled-blue-btn" (click)="createQuoteForNewLead()" *ngIf="!leadId && !showApproveBtn && orgType !== ORGANIZATION_TYPES.DMC">
            Create Quote
          </ion-button>

          <ion-button class="filled-blue-btn" (click)="approvePackage()" *ngIf="!leadId && showApproveBtn && !viewOnly">
            Approve
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="editPackage()" *ngIf="!leadId && !viewOnly">
            Edit
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="printPackage()" *ngIf="!leadId">
            Download
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="createQuote()" *ngIf="leadId && !viewOnly">
            Create Quote
          </ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content" >
      <div class="d-flex justify-content-center" [innerHTML]="packageDataHtml">
      </div>
    </div>

  </form>
</ion-content>



<!-- ---------------------- -->
  